import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {HttpErrorHandler} from '../../http.error.handler';
import {TenantApiKey} from '../../shared/models/tenant-api-key';
import {JsonApiResponse} from '../../shared/models/JsonApiResponse';


@Injectable({
  providedIn: 'root'
})
export class TenantApiKeysService {

  constructor(private http: HttpClient) { }

  getApiKeys() {
    return this.http.get<JsonApiResponse<TenantApiKey[]>>(`${environment.services.service}v1/configuration/tenant/api-keys`, {})
      .pipe(
        catchError(HttpErrorHandler.handleError) // then handle the error
      );
  }

}
